import React from "react";
import {
  connect
} from "react-redux";
import {
  getUsers,
  removeUser,
  assignRole
} from "../../actions/user";
import {
  USER_ROLES
} from "../../utils/constant";
import {
  getRole,
  capitalize
} from "../../utils/tools";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
} from "reactstrap";
import qs from "query-string";
import debounce from "lodash/debounce";

import DropdownSelection from '../../components/Commons/DropdownSelection';
import SearchBar from '../../components/Commons/SearchBar';
import DataTable from '../../components/Commons/DataTable';
import PaginationBar from '../../components/Commons/PaginationBar';
import UserModal from '../../components/Users/UserModal.jsx';

class UsersPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      openUserModal: false,
      selectedUser: {},
      activeUserType: null,
      users: [],
    };
    this.goToPage = this.goToPage.bind(this);
    this.filterType = this.filterType.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.toggleUserModal = this.toggleUserModal.bind(this);
    this.onRoleChange = this.onRoleChange.bind(this);
    this.assignRole = this.assignRole.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);
    let { role_id } = urlParams;
    let activeUserType = getRole(role_id);
    this.setState({
      ...this.state,
      ...urlParams,
      activeUserType
    });

    this.getUsers({ ...urlParams });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location !== this.props.location) {
      let urlParams = qs.parse(newProps.search);
      this.getUsers(urlParams);
    }
  }

  getUsers(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params
    };
    this.props.getUsers(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterType(role) {
    let activeUserType = getRole(role);
    this.setState({
      activeUserType
    });
    let role_id = role;
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      role_id
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  handleSearch = debounce(searchStr => {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      keyword: searchStr
    };
    delete searchParams.page;
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }, 1000);

  onSearchInputChange(e) {
    let searchStr = e.target.value;
    this.setState({
      keyword: searchStr
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      keyword: searchStr,
      page: 1
    };
    delete searchParams.page;
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  toggleUserModal(row = {}) {
    this.setState({
      openUserModal: !this.state.openUserModal,
      selectedUser: row
    });
  }

  onRoleChange(role) {
    let user = { ...this.state.selectedUser };
    user.role.id = role;
    this.setState({
      selectedUser: user
    });
  }

  assignRole() {
    let user = { ...this.state.selectedUser };
    let role_id = user.role.id;
    this.props.assignRole({ user_id: user.id, role_id: role_id });
    this.toggleUserModal();
  }



  render() {
    const {
      users,
      usersPagination,
      getUsersRequest
    } = this.props.user;
    var activeUserType = this.state.activeUserType;

    const heads = ['身份', '姓名', '公開暱稱', '電話', '郵箱', '操作'];
    const dataAttributes = ['role', 'name', 'pseudonym', 'phone', 'email',];

    return (
      <Container className="mt-4" fluid>
        {this.state.alert}
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between">
              <DropdownSelection Types={USER_ROLES} activeType={activeUserType} filterType={this.filterType} />
              <SearchBar search_string={this.state.keyword} onSearchInputChange={this.onSearchInputChange} />
            </div>
          </CardHeader>
          <DataTable
            heads={heads}
            dataAttributes={dataAttributes}
            rows={users}
            loading={getUsersRequest}
            changeRole={this.toggleUserModal}
          />
          <CardFooter className="py-4 d-flex justify-content-center">
            {usersPagination.currentPage ? (
              <PaginationBar
                currentPage={usersPagination.currentPage}
                totalPages={usersPagination.lastPage}
                pageNeighbours={1}
                goToPage={page => this.goToPage(page)}
              />
            ) : null}
          </CardFooter>
        </Card>
        <UserModal
          open={this.state.openUserModal}
          toggle={this.toggleUserModal}
          user={this.state.selectedUser}
          onRoleChange={this.onRoleChange}
          confirm={this.assignRole}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getUsers: params => dispatch(getUsers(params)),
    removeUser: params => dispatch(removeUser(params)),
    assignRole: params => dispatch(assignRole(params))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersPage);